// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CircleDashedBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M11.547 4.756a1.501 1.501 0 0 1 1.078-1.828 13.5 13.5 0 0 1 6.75 0 1.5 1.5 0 1 1-.75 2.903 10.514 10.514 0 0 0-5.25 0 1.5 1.5 0 0 1-1.828-1.075Zm-5.18 1.787a13.513 13.513 0 0 0-3.375 5.844 1.5 1.5 0 1 0 2.892.8 10.5 10.5 0 0 1 2.625-4.543 1.5 1.5 0 0 0-2.142-2.101ZM5.882 18.81a1.5 1.5 0 0 0-2.89.803 13.5 13.5 0 0 0 3.375 5.847A1.5 1.5 0 0 0 8.5 23.356a10.5 10.5 0 0 1-2.618-4.546Zm12.743 7.359a10.501 10.501 0 0 1-5.25 0 1.5 1.5 0 1 0-.75 2.904 13.5 13.5 0 0 0 6.75 0 1.5 1.5 0 1 0-.75-2.904Zm9.34-8.403a1.5 1.5 0 0 0-1.84 1.047 10.5 10.5 0 0 1-2.625 4.543 1.5 1.5 0 1 0 2.14 2.103 13.524 13.524 0 0 0 3.375-5.846 1.499 1.499 0 0 0-1.051-1.847Zm-1.846-4.576a1.5 1.5 0 0 0 2.89-.803 13.5 13.5 0 0 0-3.375-5.847A1.5 1.5 0 1 0 23.5 8.644a10.5 10.5 0 0 1 2.617 4.546h.002Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
